import "./r_sidebar.css";
import R_Header from "../layouts/Header/components/R_Header";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";
import { useState } from "react";


const R_Sidebar = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const { pathname } = useLocation();
    // Credit Logs lives under Manage Users (its Credit Logs button).
    const inManageUsers = pathname.startsWith("/credit-logs");
    const roleId = useSelector((state: RootState) => state.auth.roleId);
    const normalizedRoleId = typeof roleId === "number" ? roleId : Number(roleId);
    const isSubUser = normalizedRoleId === 6;

    const closeMobile = () => setMobileOpen(false);

    return (

        <>
            <R_Header />

            {/* Hamburger button — visible on mobile only, hidden when sidebar is open */}
             {!mobileOpen && (
                <button className="side-panel-toggle" onClick={() => setMobileOpen(true)}>
                    <img src="https://img.icons8.com/ios-filled/50/164966/menu--v1.png" alt="Open menu" />
                </button>
            )}

            {/* Backdrop overlay — tap to close sidebar */}
            {mobileOpen && <div className="side-panel-overlay" onClick={closeMobile} />}

            <aside className={`side-panel${mobileOpen ? " open" : ""}`}>
                <div className="side-panel-logo">
                    <img src="/images/right-emails-logo.svg" alt="Logo" />
                    <div className="logo-divider"></div>
                </div>

                <ul className="side-panel-menu">
                    {/* Dashboard */}
                    <li className="side-panel-item">
                        <NavLink
                            to="/dashboard"
                            onClick={closeMobile}
                            className={({ isActive }) =>
                                `side-panel-link ${isActive ? "is-active" : ""}`
                            }
                        >
                            <span className="side-panel-icon">
                                <img src="/images/home.png" className="icon-normal" alt="" />
                                <img src="/images/active-home.png" className="icon-hover" alt="" />
                            </span>
                            <span className="side-panel-text">Dashboard</span>
                        </NavLink>
                    </li>

                    {/* Email Verifier */}
                    <li className="side-panel-item">
                        <NavLink
                            to="/email-verifier"
                            onClick={closeMobile}
                            className={({ isActive }) =>
                                `side-panel-link ${isActive ? "is-active" : ""}`
                            }
                        >
                            <span className="side-panel-icon">
                                <img src="/images/email-verifire.png" className="icon-normal" alt="" />
                                <img src="/images/email-verifire-active.png" className="icon-hover" alt="" />
                            </span>
                            <span className="side-panel-text">Email Verifier</span>
                        </NavLink>
                    </li>
                    {/* Pricing */}
                    {!isSubUser && (
                        <li className="side-panel-item">
                            <NavLink
                                to="/pricing"
                                className={({ isActive }) =>
                                    `side-panel-link ${isActive ? "is-active" : ""}`
                                }
                            >
                                <span className="side-panel-icon">
                                    <img
                                        src="/images/pricing.png"
                                        className="icon-normal"
                                        alt=""
                                    />

                                    <img
                                        src="/images/pricing-active.png"
                                        className="icon-hover"
                                        alt=""
                                    />
                                </span>

                                <span className="side-panel-text">
                                    Pricing
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {/* API */}
                    {!isSubUser && (
                        <li className="side-panel-item">
                            <NavLink
                                to="/api-access"
                                onClick={closeMobile}
                                className={({ isActive }) =>
                                    `side-panel-link ${isActive ? "is-active" : ""}`
                                }
                            >
                                <span className="side-panel-icon">
                                    <img src="/images/api-code.svg" className="icon-normal" alt="" />
                                    <img src="/images/api-code-active.svg" className="icon-hover" alt="" />
                                </span>
                                <span className="side-panel-text">API</span>
                            </NavLink>
                        </li>
                    )}

                    {/* Integration */}
                    {!isSubUser && (
                        <li className="side-panel-item">
                            <NavLink
                                to="/integration"
                                onClick={closeMobile}
                                className={({ isActive }) =>
                                    `side-panel-link ${isActive ? "is-active" : ""}`
                                }
                            >
                                <span className="side-panel-icon">
                                    <img src="/images/integration.png" className="icon-normal" alt="" />
                                    <img src="/images/integration-active.png" className="icon-hover" alt="" />
                                </span>
                                <span className="side-panel-text">Integrations</span>
                            </NavLink>
                        </li>
                    )}

                </ul>

                <div className="logo-divider-2"></div>
                <ul className="side-panel-menu">
                    {/* Manage Users */}
                    {normalizedRoleId !== 6 && (
                        <li className="side-panel-item">
                            <NavLink
                                to="/manage_users"
                                onClick={closeMobile}
                                className={({ isActive }) =>
                                    `side-panel-link ${isActive || inManageUsers ? "is-active" : ""}`
                                }
                            >
                                <span className="side-panel-icon">
                                    <img src="/images/users.png" className="icon-normal" alt="" />
                                    <img src="/images/users-active.png" className="icon-hover" alt="" />
                                </span>
                                <span className="side-panel-text">Manage Users</span>
                            </NavLink>
                        </li>
                    )}

                    {/* Verification Logs */}
                    <li className="side-panel-item">
                        <NavLink
                            to="/verification-logs"
                            onClick={closeMobile}
                            className={({ isActive }) =>
                                `side-panel-link ${isActive ? "is-active" : ""}`
                            }
                        >
                            <span className="side-panel-icon">
                                <img src="/images/verification-logs.png" className="icon-normal" alt="" />
                                <img src="/images/verification-logs-active.png" className="icon-hover" alt="" />
                            </span>
                            <span className="side-panel-text">Verification Logs</span>
                        </NavLink>
                    </li>
                </ul>
            </aside>
        </>

    );
};

export default R_Sidebar;
